// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pac-container .pac-item .pac-item-query,.pac-container .pac-item .pac-item-query .pac-matched{color:rgba(0,0,0,.87)}.pac-container .pac-item>span{color:rgba(0,0,0,.66)}", ""]);
// Exports
module.exports = exports;
